// @flow
import React from "react";
import { Button, Form, FormGroup, Col } from "reactstrap";
import { useNavigation, useCurrentRoute } from "react-navi";
import axios from "axios";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import GeneralSettings from "./config-form-sections/GeneralSettings";
import PrintSettings from "./config-form-sections/PrintSettings";
import ApplicationCustomization from "./config-form-sections/ApplicationCustomization";
import SharingSettings from "./config-form-sections/SharingSettings";
import ActiveModeSettings from "./config-form-sections/ActiveModeSettings";
import { useConfigImages, useConfig } from "../../hooks/configHooks";
import Loading from "../loading";
import Container from "../components/Container";
import configService from "../../services/api/configService";
import GameSettings from "./config-form-sections/GameSettings";
import SmsSetting from "./config-form-sections/SmsSettings"
import FiltresSetting from "./config-form-sections/FiltresSettings"
import PrintPriceSetting from "./config-form-sections/PrintPriceSetting"

export function ConfigForm() {
  const route = useCurrentRoute();
  const navigation = useNavigation();

  const config = useSelector(state => {
    return state.configReducer.config;
  });
  const eventIdExists = useSelector(
    state => state.generalReducer.eventIdExists
  );

  const { isEditing, machineId, config: routeConfig } = route.data;

  useConfig(isEditing, machineId, routeConfig);
  useConfigImages(isEditing);

  async function handleSubmit(event) {
    event.persist();
    event.preventDefault();

    if (eventIdExists) return;

    const data = new FormData();

    // Adding data to form
    const configKeys = Object.keys(config);
    for (let i = 0; i < configKeys.length; i += 1) {
      if (config[configKeys[i]] !== "") {
        data.append(configKeys[i], config[configKeys[i]]);
      }
    }

    // If this is a config creation then we send a post request
    if (!route.data.isEditing) {
      configService.createConfig(data);
    } else {
      // Otherwise a send a put request
      configService.updateConfig(config.eventId, data);
    }
    navigation.navigate("/machines/".concat(config.machineId, "/configs"));
  }

  // #endregion
  const gameset = config.setting!=8 ? (<GameSettings/>) :null ;
  const smsSet = config.setting!=8 ? (<SmsSetting></SmsSetting>) :null ;
  const filtresSet =config.setting!=8 ? <FiltresSetting></FiltresSetting> :null ;
  const priceSetting =config.setting==8 ? <PrintPriceSetting></PrintPriceSetting> : null ;
  return (
    <Container title="Please fill in the form below">
      <Form onSubmit={handleSubmit}>
        <GeneralSettings />
        <ActiveModeSettings setting={config.setting} />
        <PrintSettings />
        {smsSet}
        { gameset}
        {filtresSet}
        {priceSetting}
        <ApplicationCustomization />
        <SharingSettings />
        <FormGroup check row className=" mb-3 d-flex justify-content-center">
          <Col>
            <Button
              outline
              className="btn-black btn-block btn btn-outline-dark"
              type="submit"
            >
              Submit
            </Button>
          </Col>
        </FormGroup>
      </Form>
    </Container>
  );
}
export default ConfigForm;



// WEBPACK FOOTER //
// ./src/views/Configuration/configform.jsx